import { http } from '../plugins/http'
import { type AxiosResponse } from 'axios'

import { Banner } from '@/types/Banner'
import type PaginatedResponse from '@/types/PaginatedResponse'
import type DataResponse from '@/types/DataResponse'

export default class BannerService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Banner>>> {
    return await http.get<PaginatedResponse<Banner>>(`/api/v1/office/banners?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string) {
    return await http.get<Banner>(`/api/v1/office/banners/${id}`)
  }

  async store(model: Banner, image?: File) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    const data = {
      ...model,
      image,
    }
    console.log('data', data)
    return await http.post<DataResponse<Banner>>(`/api/v1/office/banners`, data, { headers })
  }

  async update(id: string, model: Banner, image?: File) {
    const headers = { 'Content-Type': 'multipart/form-data' }

    const data = {
      ...model,
      image,
      _method: 'PUT',
    }

    return await http.post<DataResponse<Banner>>(`/api/v1/office/banners/${id}`, data, { headers })
  }

  async destroy(id: string) {
    return await http.delete(`/api/v1/office/banners/${id}`)
  }

  async updateSortingOrder(sortedIds: string[]) {
    return await http.put<PaginatedResponse<Banner>>(`/api/v1/office/banners/sorting`, { ids: sortedIds })
  }
}
